import React from 'react';
import CloseIcon from 'images/common/CloseModal.svg';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import {ThemeProvider} from '@components/@theme';
import {lightTheme} from '@components/@theme/lightTheme';
import {deleteLibraryTag} from 'sources/library/LibrarySource.utils';

/**
 * Confirmation dialog rendered to confirm a user really wants to remove a call from a library.
 *
 * @param libraryTagToDelete the tag that will be deleted if the user confirms.
 */
export default function LibraryTagDeleteDialog({libraryTagToDelete, onClose}) {
  let dialogTitle;
  if (libraryTagToDelete) {
    dialogTitle = `Remove tag "${libraryTagToDelete.tag_name}"?`;
  }
  const openLibraryTagDeleteDialog = !!libraryTagToDelete;

  return (
    <Dialog
      open={openLibraryTagDeleteDialog}
      modal={true}
      title={dialogTitle}
      contentStyle={{maxWidth: '524px'}}
      onRequestClose={onClose}>
      <img alt="dialog close" className="dialog-close-button" src={CloseIcon} onClick={onClose} />
      <div>
        <span className="title-description">
          {libraryTagToDelete
            ? `Are you sure you want to remove the tag "${libraryTagToDelete.tag_name}" from this call in "${libraryTagToDelete.library_name}"?`
            : null}
        </span>
      </div>
      <ThemeProvider theme={lightTheme}>
        <div className="dialog-button-row">
          <Button
            variant="outlined"
            className="submit create-or-update"
            style={{marginLeft: '0px'}}
            onClick={onClose}>
            No, Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            className="submit delete"
            onClick={async () => {
              await deleteLibraryTag(libraryTagToDelete);
              onClose();
            }}>
            Yes, Remove
          </Button>
        </div>
      </ThemeProvider>
    </Dialog>
  );
}
